import React from 'react'
import { Box } from '@mui/material'
import { LoaderWrapper, Loader } from './style'

const LoaderDotted = ({ msg = '' }) => {
  return (
    <LoaderWrapper>
      {msg && <b>{msg}</b>}
      <Loader className={`load-3 ${msg ? 'hasMsg' : ''}`}>
        <div className='line'></div>
        <div className='line'></div>
        <div className='line'></div>
      </Loader>
    </LoaderWrapper>
  )
}
export default LoaderDotted
